"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloseButton = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const styled_1 = __importDefault(require("../../styles/styled"));
const Rectangle = styled_1.default.div(props => {
    return {
        position: 'absolute',
        width: '20px',
        height: '2px',
        transform: `rotate(${props.rotation}deg)`,
        borderRadius: '1px',
        backgroundColor: props.theme.colors.grey90,
        cursor: 'pointer',
    };
});
const ButtonWrapper = styled_1.default.button({
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '20px',
    height: '20px',
    marginLeft: '10px',
    border: 'none',
    cursor: 'pointer',
    backgroundColor: 'transparent',
});
const CloseButton = props => {
    return ((0, jsx_runtime_1.jsxs)(ButtonWrapper, Object.assign({ "aria-label": props.label }, props, { children: [(0, jsx_runtime_1.jsx)(Rectangle, { rotation: 45 }), (0, jsx_runtime_1.jsx)(Rectangle, { rotation: -45 })] })));
};
exports.CloseButton = CloseButton;
//# sourceMappingURL=close_button.js.map